import { IMarketFeedResponse } from "@finbackoffice/clientbff-client";
import { HOUR_IN_MS, sortSports } from "@finbackoffice/fe-core";
import {
    HoursRange,
    IEventFeedResponse,
    ISportFeedResponse,
    ITopLeagueFeedResponse,
} from "@finbackoffice/websocket-client";
import { endOfDay } from "date-fns";

export const convertGamesToSports = (
    games: IEventFeedResponse[],
    sportsOrder?: number[],
): ISportFeedResponse[] => {
    const sportsData: ISportFeedResponse[] = [];

    for (let i = 0; i < games.length; ++i) {
        const game = games[i];
        const sportIndex = sportsData.findIndex((sport) => sport.id === game.sport_id);

        if (sportIndex === -1) {
            const sportData: ISportFeedResponse = {
                id: game.sport_id,
                name: game.sport_name,
                slug: game.sport_slug,
                games_count: 1,
                categories: [],
            };

            sportsData.push(sportData);
        } else {
            sportsData[sportIndex].games_count++;
        }
    }

    if (sportsOrder?.length) {
        return sportsData.sort((a, b) => sortSports(sportsOrder)(a, b));
    }

    return sportsData;
};

export const convertGamesToTournaments = (
    games: IEventFeedResponse[],
): ITopLeagueFeedResponse[] => {
    const tournaments: ITopLeagueFeedResponse[] = [];

    for (let i = 0; i < games.length; ++i) {
        const game = games[i];
        const tournamentIndex = tournaments.findIndex(
            (tournament) => tournament.id === game.tournament_id,
        );

        if (tournamentIndex === -1) {
            const tournament: ITopLeagueFeedResponse = {
                id: game.tournament_id,
                name: game.tournament_name,
                sport_id: game.sport_id,
                sport_slug: game.sport_slug,
                sport_name: game.sport_name,
                category_name: game.category_name,
                category_id: game.category_id,
                is_top: game.tournament_is_top,
                top_index: game.tournament_top_index,
                events: [game.id],
                games_count: 1,
            };

            tournaments.push(tournament);
        } else {
            tournaments[tournamentIndex].games_count++;
            tournaments[tournamentIndex].events.push(game.id);
        }
    }

    return tournaments;
};

export const calculateRestOfDayInHoursRange = (): HoursRange => {
    const restOfDayInMS = endOfDay(new Date()).getTime() - new Date().getTime();
    const restOfDayInHours = Math.ceil(restOfDayInMS / HOUR_IN_MS);
    const ranges = Object.values(HoursRange).filter(
        (value) => typeof value === "number",
    ) as number[];
    ranges.sort((a, b) => a - b);

    for (const range of ranges) {
        if (range >= restOfDayInHours) {
            return range as HoursRange;
        }
    }

    return HoursRange.TWELVE;
};

export const moveMarketToFirstByIndex = (arr: IMarketFeedResponse[], index: number) => {
    if (index < 0 || index >= arr.length) {
        return arr;
    }

    const arrCopy = [...arr];
    const [elementToMove] = arrCopy.splice(index, 1);

    return [elementToMove, ...arrCopy];
};

export const findMainMarket = (
    markets: IMarketFeedResponse[],
    mainMarketGroupIds: number | number[],
) => {
    let mainMarket;
    if (typeof mainMarketGroupIds === "number") {
        mainMarket = markets?.find((market) => market.template_id === mainMarketGroupIds);
    } else {
        mainMarketGroupIds.some((id) => {
            const result = markets?.find((market) => market.template_id === id);
            if (result) {
                mainMarket = result;
                return true;
            }
        });
    }

    return mainMarket;
};

export const getColumnCount = (outcomesCount: number) => {
    return outcomesCount > 2 ? 3 : 2;
};
